(() => {
  const SAMPLE_HANDLE = 'free-kratom-sample-pack';
  let normalizing = false;
  let scheduled = false;

  const scheduleNormalization = () => {
    const uncheckedSampleLine = document.querySelector('[data-kp-sample-item]:not([data-kp-sample-guard-checked])');
    if (scheduled || normalizing || !uncheckedSampleLine) return;
    scheduled = true;
    window.setTimeout(() => {
      scheduled = false;
      normalizeSampleLines();
    }, 120);
  };

  const normalizeSampleLines = async () => {
    if (normalizing) return;
    normalizing = true;
    try {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const sampleLines = cart.items.filter(
        (item) => item.handle === SAMPLE_HANDLE || item.product_handle === SAMPLE_HANDLE
      );
      const sampleQuantity = sampleLines.reduce((total, item) => total + item.quantity, 0);
      if (sampleLines.length <= 1 && sampleQuantity <= 1) {
        document.querySelectorAll('[data-kp-sample-item]').forEach((line) => {
          line.setAttribute('data-kp-sample-guard-checked', 'true');
        });
        return;
      }

      const updates = {};
      sampleLines.forEach((item, index) => {
        updates[item.key] = index === 0 ? 1 : 0;
      });
      const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!updateResponse.ok) return;
      window.location.reload();
    } catch (_error) {
      // The storefront remains usable if the advisory normalization request fails.
    } finally {
      normalizing = false;
    }
  };

  document.addEventListener('DOMContentLoaded', scheduleNormalization);
  new MutationObserver(scheduleNormalization).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
